<!--
  <SmoothReflow class="overflow-hidden transition-all duration-200 ease-in-out">
    <div :class="{ 'h-auto': isOpen, 'h-0': !isOpen }">
      Hello World!
    </div>
  </SmoothReflow>
-->

<template>
  <component :is="tag">
    <slot />
  </component>
</template>

<script>
// https://github.com/guanzo/vue-smooth-reflow#smooth-component
import smoothReflow from 'vue-smooth-reflow'

export default {
  mixins: [smoothReflow],
  props: {
    tag: { type: String, default: 'div' },
    options: { type: Object, default: () => ({}) },
  },
  mounted() {
    this.$smoothReflow(this.options)
  },
}
</script>
